import { useSession } from "@outschool/ui-auth";
import { useRequiresMembershipForEnrollment } from "@outschool/ui-components-website";
import React from "react";

export default function useCDPMembershipModal() {
  const {
    requiresMembershipForEnrollment,
    requiresEsaMembershipForEnrollment
  } = useRequiresMembershipForEnrollment();

  const { currentUser } = useSession();

  const isMembershipNeeded =
    (requiresMembershipForEnrollment &&
      (!currentUser?.hasSubscription ||
        !currentUser?.canPayWithSubscriptionCredits) &&
      !currentUser?.hasEsaMembership) ||
    requiresEsaMembershipForEnrollment;

  const shouldShowCDPMembershipModal = isMembershipNeeded;

  // TODO: Remove the button in JoinMembershipModal's JoinMembershipEnrollmentContent that allows snoozing the modal
  // since that was only an option to users who have requiresMembershipForEnrollment=false
  // and now the only users who see the modal are those who have requiresMembershipForEnrollment=true
  const snoozeCDPMembershipModal = React.useCallback(() => {}, []);

  return {
    snoozeCDPMembershipModal,
    shouldShowCDPMembershipModal
  };
}
